import React, {Component} from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/common/Blog.module.scss';
import Slider from 'react-slick';
import Image from './Image';
import { blogSectionClicked } from '../../tracking/segment/planPage';
//  <Image src={banner_img || ''} alt={title} width="730" height="516" /> 


interface BlogProps {
    blog: any,
    title: string,
    category?: any
}

const PrevArrow = (props) => {
  return(
    <a className={`${styles._arrow} ${styles._arrow_prev}`} href="#" onClick={props.onClick}></a>
  );
}


const NextArrow = (props) => {
  return(
    <a className={`${styles._arrow} ${styles._arrow_next}`} href="#" onClick={props.onClick}></a>
  );
}
class Blog extends Component<BlogProps> {
   
  render() {
    const settings = {
      infinite: this.props.blog.length>3?true:false,
      speed: 500,
      slidesToShow:3,
      slidesToScroll: 1,
      arrows:true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
  
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: this.props.blog.length>2?true:false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: this.props.blog.length>2?true:false,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: this.props.blog.length>2?true:false,
          }
        },
      ]
    } ;
    const blogs = this.props.blog;
    let content = <></>;
    if(blogs.length > 0){
      content = <Section hasPadding={true} dataBg="shade-1" className="blogs-section" title={this.props.title}>
        <div className="container">
          <Slider className={`${styles.slick_slider}`} {...settings}>
            {blogs.map((item, index)=>{
              return(
                <div key={`blog-${item.id}`} className={`${styles.blog_container}`}>
                  <div className={`${styles._image}`}>
                    <Image src={item.image || ''} alt={item.title} width="730" height="516" /> 
                  </div>
                  <div className={styles._title}>{item.title}</div>
                  <a href={`${item.link}`} onClick={(e)=>{ blogSectionClicked({ 'blog_title':item.title, 'blog_url':item.link, 'category':this.props.category }) }} target="_blank" className={styles._link}>Read More     </a> 
                </div>
              );
            })}
          </Slider>
        </div>
      </Section>
    }
    return content;
  }
}
export default Blog;
